export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";